/*
 * The homepage Shop by Color section remains block-driven. The header's
 * Men/Women mega-menu color column is API-driven from the same first-party
 * color source used elsewhere in the theme.
 */
(function () {
  'use strict';

  var colorsPromise = null;
  var menGarmentEligibilityPromise = null;
  var MEN_GARMENT_CATEGORIES = {
    'scrub-tops': true,
    'scrub-pants': true,
    jackets: true,
    underscrubs: true,
    jumpsuits: true
  };

  function normalizeColorIdentity(value) {
    var identity = String(value || '').toLowerCase().replace(/[^a-z0-9]/g, '');
    // The family catalogue and /v1/colors use both Vital/Vitals Navy spellings.
    return identity === 'vitalsnavy' ? 'vitalnavy' : identity;
  }

  function addColorIdentities(target, color) {
    [color && color.slug, color && color.color, color && color.name].forEach(function (value) {
      var identity = normalizeColorIdentity(value);
      if (identity) target[identity] = true;
    });
  }

  function getColors() {
    if (!colorsPromise) {
      colorsPromise = window.HealixColors && typeof window.HealixColors.colors === 'function'
        ? window.HealixColors.colors().then(function (items) { return Array.isArray(items) ? items : []; }).catch(function () { return []; })
        : Promise.resolve([]);
    }
    return colorsPromise;
  }

  function getMenGarmentEligibility() {
    if (menGarmentEligibilityPromise) return menGarmentEligibilityPromise;
    var library = window.HealixColors;
    if (!library || typeof library.catalogFamilies !== 'function') return Promise.resolve(null);

    menGarmentEligibilityPromise = Promise.resolve(library.catalogFamilies()).then(function (families) {
      if (!Array.isArray(families) || !families.length) return null;
      var eligible = {};
      families.forEach(function (family) {
        var gender = String(family && family.navGender || '').trim().toLowerCase();
        var category = String(family && family.navCategory || '').trim().toLowerCase();
        if (gender !== 'men' || !MEN_GARMENT_CATEGORIES[category]) return;
        (Array.isArray(family && family.colors) ? family.colors : []).forEach(function (color) {
          addColorIdentities(eligible, color);
        });
      });
      return Object.keys(eligible).length ? eligible : null;
    }).catch(function () {
      return null;
    });
    return menGarmentEligibilityPromise;
  }

  function collectionUrl(handle) {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    if (root.slice(-1) !== '/') root += '/';
    return handle ? root + 'collections/' + encodeURIComponent(handle) : '#';
  }

  function initShopByColorGender(section) {
    if (!section || section.dataset.sbcGenderInitialized === 'true') return;
    var buttons = section.querySelectorAll('[data-sbc-gender]');
    var cards = section.querySelectorAll('[data-sbc-gender-card]');
    if (!buttons.length || !cards.length) return;

    section.dataset.sbcGenderInitialized = 'true';
    function setGender(gender) {
      buttons.forEach(function (button) {
        var active = button.dataset.sbcGender === gender;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
      cards.forEach(function (card) {
        card.style.display = card.dataset.sbcGenderCard === gender ? '' : 'none';
      });
      var rowWrap = section.querySelector('[data-sbc-row-wrap]');
      if (rowWrap) rowWrap.dispatchEvent(new CustomEvent('sbc:genderchange'));
    }
    buttons.forEach(function (button) {
      button.addEventListener('click', function () { setGender(button.dataset.sbcGender); });
    });
    setGender('women');
  }

  function initSlider(container) {
    if (!container || container.dataset.sbcSliderInitialized === 'true') return;
    var slider = container.querySelector('[data-sbc-slider]') || container.querySelector('.sbc-row');
    var prev = container.querySelector('[data-sbc-slider-prev]');
    var next = container.querySelector('[data-sbc-slider-next]');
    if (!slider || !prev || !next) return;

    container.dataset.sbcSliderInitialized = 'true';

    var scrub = document.createElement('div');
    scrub.className = 'sbc-scrub';
    var track = document.createElement('div');
    track.className = 'sbc-scrub__track';
    var handle = document.createElement('div');
    handle.className = 'sbc-scrub__handle';
    handle.tabIndex = 0;
    handle.setAttribute('role', 'scrollbar');
    handle.setAttribute('aria-label', 'Scroll shop by color');
    handle.setAttribute('aria-orientation', 'horizontal');
    handle.setAttribute('aria-valuemin', '0');
    handle.setAttribute('aria-valuemax', '100');
    track.appendChild(handle);
    scrub.appendChild(track);
    container.insertAdjacentElement('afterend', scrub);

    function maxScroll() {
      return Math.max(0, slider.scrollWidth - slider.clientWidth);
    }

    function arrowTop() {
      var image = slider.querySelector(
        '.sbc-swatch:not([style*="display: none"]) .sbc-swatch__dot'
      );
      if (!image) return container.clientHeight * 0.5;
      var imageRect = image.getBoundingClientRect();
      var containerRect = container.getBoundingClientRect();
      return imageRect.top - containerRect.top + imageRect.height * 0.5;
    }

    function update() {
      var max = maxScroll();
      var start = slider.scrollLeft <= 2;
      var end = slider.scrollLeft >= max - 2;
      prev.disabled = start;
      next.disabled = end;
      prev.hidden = max <= 2 || start;
      next.hidden = max <= 2 || end;
      var top = arrowTop() + 'px';
      prev.style.top = top;
      next.style.top = top;

      if (max <= 2) {
        scrub.hidden = true;
        return;
      }
      scrub.hidden = false;
      var range = track.clientWidth - handle.offsetWidth;
      var x = range * (slider.scrollLeft / max);
      handle.style.transform = 'translateX(' + Math.max(0, x) + 'px)';
      handle.setAttribute('aria-valuenow', String(Math.round((slider.scrollLeft / max) * 100)));
    }

    function amount() {
      var card = slider.querySelector('.sbc-swatch:not([style*="display: none"])');
      if (!card) return slider.clientWidth * 0.8;
      var rowStyle = window.getComputedStyle ? window.getComputedStyle(slider) : null;
      var gap = rowStyle ? parseFloat(rowStyle.columnGap || rowStyle.gap) || 0 : 0;
      return card.getBoundingClientRect().width + gap;
    }

    function scrollByCard(direction) {
      var reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      slider.scrollBy({ left: amount() * direction, behavior: reducedMotion ? 'auto' : 'smooth' });
    }

    prev.addEventListener('click', function () { scrollByCard(-1); });
    next.addEventListener('click', function () { scrollByCard(1); });

    var drag = null;
    handle.addEventListener('pointerdown', function (event) {
      drag = { x: event.clientX, left: slider.scrollLeft };
      if (handle.setPointerCapture) handle.setPointerCapture(event.pointerId);
      scrub.classList.add('is-dragging');
      event.preventDefault();
    });
    handle.addEventListener('pointermove', function (event) {
      if (!drag) return;
      var range = track.clientWidth - handle.offsetWidth;
      var max = maxScroll();
      if (range <= 0 || max <= 0) return;
      slider.scrollLeft = drag.left + (event.clientX - drag.x) * (max / range);
    });
    function endDrag() {
      drag = null;
      scrub.classList.remove('is-dragging');
    }
    handle.addEventListener('pointerup', endDrag);
    handle.addEventListener('pointercancel', endDrag);

    scrub.addEventListener('pointerdown', function (event) {
      if (event.target === handle || drag) return;
      var rect = track.getBoundingClientRect();
      var range = rect.width - handle.offsetWidth;
      if (range <= 0) return;
      var ratio = (event.clientX - rect.left - handle.offsetWidth * 0.5) / range;
      ratio = Math.max(0, Math.min(1, ratio));
      slider.scrollTo({ left: ratio * maxScroll(), behavior: 'smooth' });
    });

    handle.addEventListener('keydown', function (event) {
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
      scrollByCard(event.key === 'ArrowLeft' ? -1 : 1);
      event.preventDefault();
    });

    slider.addEventListener('scroll', update, { passive: true });
    if ('ResizeObserver' in window) {
      var observer = new window.ResizeObserver(update);
      observer.observe(slider);
      observer.observe(track);
    } else {
      window.addEventListener('resize', update);
    }
    container.addEventListener('sbc:genderchange', function () {
      slider.scrollLeft = 0;
      update();
    });
    update();
  }

  function makeMenuCard(color, gender, asListItem) {
    var handle = color && color.collections && color.collections[gender];
    if (!handle) return null;
    var item = asListItem ? document.createElement('li') : null;
    if (item) {
      item.dataset.sbcMenuCardGender = gender;
    }
    var card = document.createElement('a');
    card.className = 'sbc-menu-swatch mega-menu__column-link';
    card.href = collectionUrl(handle);
    if (!item) card.dataset.sbcMenuCardGender = gender;
    card.setAttribute('role', 'listitem');
    card.setAttribute('aria-label', color.name || 'Shop color');

    var chip = document.createElement('span');
    chip.className = 'sbc-menu-swatch__chip';
    chip.style.backgroundColor = color.hex || '#eceef1';
    chip.setAttribute('aria-hidden', 'true');

    card.appendChild(chip);

    var name = document.createElement('span');
    name.className = 'sbc-menu-swatch__name';
    name.textContent = color.name || '';
    card.appendChild(name);
    if (item) {
      item.appendChild(card);
      return item;
    }
    return card;
  }

  function setMenuGender(root, gender) {
    root.querySelectorAll('[data-sbc-menu-gender]').forEach(function (button) {
      var active = button.dataset.sbcMenuGender === gender;
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
    root.querySelectorAll('[data-sbc-menu-card-gender]').forEach(function (card) {
      card.hidden = card.dataset.sbcMenuCardGender !== gender;
    });
  }

  function getMenuColors(gender) {
    if (gender !== 'men') return getColors().then(function (colors) {
      return { colors: colors, eligibility: null };
    });
    return Promise.all([getColors(), getMenGarmentEligibility()]).then(function (values) {
      return { colors: values[0], eligibility: values[1] };
    });
  }

  function renderColorRows(root, gender) {
    getMenuColors(gender).then(function (result) {
      var colors = result.colors;
      var eligibility = result.eligibility;
      var asListItem = root.hasAttribute('data-sbc-mega-color');
      root.querySelectorAll('[data-sbc-menu-row]').forEach(function (row) {
        var edition = row.dataset.sbcMenuRow;
        row.innerHTML = '';
        colors.filter(function (color) {
          if ((color.edition || 'core') !== edition) return false;
          return gender !== 'men'
            ? true
            : Boolean(eligibility && (
              eligibility[normalizeColorIdentity(color.slug)] ||
              eligibility[normalizeColorIdentity(color.color)] ||
              eligibility[normalizeColorIdentity(color.name)]
            ));
        }).forEach(function (color) {
          var card = makeMenuCard(color, gender, asListItem);
          if (card) row.appendChild(card);
        });
      });
      setMenuGender(root, gender);
    });
  }

  function initColorMenu(root) {
    if (!root || root.dataset.sbcMenuInitialized === 'true') return;
    root.dataset.sbcMenuInitialized = 'true';
    root.querySelectorAll('[data-sbc-menu-gender]').forEach(function (button) {
      button.addEventListener('click', function () {
        var gender = button.dataset.sbcMenuGender;
        renderColorRows(root, gender);
      });
    });
    renderColorRows(root, root.dataset.sbcMenuGender || 'women');
  }

  function initAll() {
    document.querySelectorAll('.shop-by-colors-section').forEach(function (section) {
      initShopByColorGender(section);
      initSlider(section.querySelector('[data-sbc-row-wrap]'));
    });
    document.querySelectorAll('[data-sbc-menu]').forEach(initColorMenu);
    document.querySelectorAll('[data-sbc-mega-color]').forEach(initColorMenu);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
